var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArabic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arabic",
    transform: "translate(21612 -2138)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4657",
    "data-name": "Rectangle 4657",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21612 2138)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_132",
    "data-name": "Subtraction 132",
    d: "M46.5,53.5H8.5a8.009,8.009,0,0,1-8-8V8.5a8.009,8.009,0,0,1,8-8h38a8.009,8.009,0,0,1,8,8v37A8.009,8.009,0,0,1,46.5,53.5ZM26.829,9.095a8.889,8.889,0,0,0-4.177,1.2,7.323,7.323,0,0,0-3.776,4.511c-1.264,4.453,1.715,9.707,1.745,9.759a21.289,21.289,0,0,0-3.253,2.908c-1.493,1.641-3.288,4.2-3.365,7.05-.073,2.689,1.369,5.188,4.284,7.427a15.356,15.356,0,0,0,9.534,3.311,21.2,21.2,0,0,0,9.465-2.51,24.1,24.1,0,0,0,3.935-2.508H41.15c-.1,0-.313.006-.607.006A38.389,38.389,0,0,1,30.9,39.048C26,37.679,23.221,35.31,22.652,32a4.967,4.967,0,0,1,.816-4.2c1.048-1.244,2.947-1.875,5.645-1.875a23.729,23.729,0,0,1,5.208.649l2.641-8.542-.011.006a22.146,22.146,0,0,1-7.222,1.622c-2.852,0-4.551-1.122-5.048-3.337a3,3,0,0,1,.309-2.589,2.946,2.946,0,0,1,2.414-.861,18.672,18.672,0,0,1,5.9,1.439,10.014,10.014,0,0,0-1.485-2.611A6.359,6.359,0,0,0,26.829,9.095Z",
    transform: "translate(-21594.5 2155.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArabic);
export default __webpack_public_path__ + "static/media/Arabic.076262f6.svg";
export { ForwardRef as ReactComponent };